let TypicalSlider = {
    init: function(slider){
        if(!slider.hasClass('slick-initialized')) {           

            let currDots = !!slider.data('typical-slider-dots'),
                currArrows = !!slider.data('typical-slider-arrows');

            slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                event.stopPropagation();

                var currIndex = (nextSlide + 1 < 10) ? 
                                    '0' + (nextSlide + 1): 
                                    (nextSlide + 1);
                // Устанавливаем в счётчике номер текущего слайда
                slider
                    .closest('[data-typical-slider-wrap]').find('[data-curr-item-counter-typical-slider]')
                    .text(currIndex);
            });

            slider.slick({
                infinite: false,
                adaptiveHeight: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnHover: false,
                pauseOnFocus: false,
                autoplay: false,
                speed: 1200,
                fade: false,
                arrows: currArrows,
                dots: currDots,
                prevArrow: '<div class="btn-arrow btn-arrow_left">'+
                                '<span class="svg-icon">'+
                                    '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg>'+
                                '</span>'+
                            '</div>',
                nextArrow: '<div class="btn-arrow">'+
                                '<span class="svg-icon">'+
                                    '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow"></use></svg>'+
                                '</span>'+
                            '</div>'
            });

            slider.find('.slick-list').on('touchstart.slick touchmove.slick mousemove.slick', function(e){
                e.stopPropagation();
            });
        }
    },
    pause: function(slider){
        slider.slick('slickPause');
    },
    play: function(slider){
        slider.slick('slickPlay');
    }
}

$(document).ready(function($) {
    
    let typicalSlider = $('[data-typical-slider]');
    if(typicalSlider.length){

        typicalSlider.each(function(index) {
            TypicalSlider.init($(this));
        });
    }
});

export default {
  init: TypicalSlider.init
};


// WEBPACK FOOTER //
// ./components/typical-slider.js